/**
 * @description: 仓库设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-store">
        <!-- 商品库存不足出货设置 -->
        <div class="store-kbc-set" v-show="show1">
            <div class="kbc-list">
                <h1 class="title">商品库存不足出货设置</h1>
                <p class="p-hint">注：【是】商品库存小于等于0时，销售商品和取酒时可以正常出货。【否】商品库存小于等于0时，销售商品和取酒时不能出货。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="kbcList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
        </div>


        <!-- 报表进货价显示设置 -->
        <div class="store-bjx-set" v-show="show2">
            <div class="bjx-list">
                <h1 class="title">报表进货价显示设置</h1>
                <p>注：</p>
                <p>1、加权平均价：每次进货价的平均值。加权平均价=每次进货总价/进货数量</p>
                <p>2、最新进货价：最近一次进货填写的进货价</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bjxList" style="margin-top:10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
            <div class="bjx-modify ele-hide" ref="bjxAlert">
                <el-form label-width="80px" v-model="bjx_form">
                    <el-select v-model="bjx_form.finance_buying_price_type" class="big" @change="onPriceTypeChange" popper-class="high-index">
                        <el-option label="最新进货价" value="1"></el-option>
                        <el-option label="加权平均价" value="2"></el-option>
                    </el-select>
                    <el-form-item label="取值范围" v-show="bjx_form.finance_buying_price_type=='2'">
                        <el-select v-model="bjx_form.limit_purchase" popper-class="high-index">
                            <el-option label="历史所有的进货价" value="-1"></el-option>
                            <el-option label="最近3次的进货价" value="3"></el-option>
                            <el-option label="最近5次的进货价" value="5"></el-option>
                            <el-option label="最近10次的进货价" value="10"></el-option>
                            <el-option label="最近20次的进货价" value="20"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="起效时间" v-show="bjx_form.finance_buying_price_type=='2'">
                        <div class="time_wrapper" ref="bjx_start_time">
                            <el-input v-model="bjx_form.start_time_str" placeholder="请选择起效时间"></el-input>
                        </div>
                    </el-form-item>
                    <div class="tip">请选择影响{{bjx_form.finance_buying_price_type==1?'最新进货价':'加权平均价'}}的采购类型</div>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllScene" @change="handleCheckAllChange">全选</el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="bjx_form.scene" @change="handleCheckedSceneChange">
                        <el-checkbox v-for="item in scenes" :label="item.value" :key="item.value">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                show1: false,
                show2: false,
                bjx_form: {
                    shop_id: '',
                    finance_buying_price_type: '1', //1最新进货价 2平均进货价
                    scene: [], //影响最新进货价的采购类型,1采购 2赠送 3盈余 4换货 5 客遗
                    limit_purchase: '-1', //取值范围,-1表示所有  如果是最新进货价的传空或者不传该参数或者原样传回
                    start_time_str: '', //起效时间 如果是最新进货价的传空或者不传该参数或者原样传回
                },
                isIndeterminate: true,
                checkAllScene: true,
                scenes: [{
                    name: '采购',
                    value: '1'
                }, {
                    name: '赠送',
                    value: '2'
                }, {
                    name: '盈余',
                    value: '3'
                }, {
                    name: '换货',
                    value: '4'
                }, {
                    name: '客遗',
                    value: '5'
                }]
            }
        },
        watch: {
            
        },
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitKbcTable()
                } else if(num == '2') {
                    this.innitBjxTable()
                    this.initStartDate()
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 商品库存不足出货设置
             */
            // 初始化商品库存不足出货设置列表
            innitKbcTable: function() {
                let _this = this;
                $(_this.$refs.kbcList).bootstrapTable('destroy');
                $(_this.$refs.kbcList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geKbcList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "check_stock",
                        title: "商品库存不足是否出货",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.kbcSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.check_stock == "-1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='-1' selected>是</option><option value='1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='-1'>是</option><option value='1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 商品库存不足出货设置列表
            geKbcList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getCheckStockSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品库存不足出货设置
            kbcSub: function(shop_id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "check_stock": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setCheckStockSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.kbcList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 报表进货价显示设置
             */
            // 初始化报表进货价显示设置列表
            innitBjxTable: function() {
                let _this = this;
                $(_this.$refs.bjxList).bootstrapTable('destroy');
                $(_this.$refs.bjxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getBjxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "适用门店",
                        width: "33%"
                    }, {
                        field: "finance_buying_price_type",
                        title: "进货价显示",
                        width: "33%",
                        formatter: function(value, row, index) {
                            if(row.finance_buying_price_type == '1') {
                                return '最新进货价';
                            } else if(row.finance_buying_price_type == '2') {
                                return '加权平均价';
                            }
                        }
                    }, {
                        title: "操作",
                        width: "33%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.openBjxModify(row);
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // 报表进货价显示设置列表
            getBjxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getFinanceBuyingPriceType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化时间
            initStartDate: function () {
                let _this = this;
                $(_this.$refs.bjx_start_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    'singleDatePicker': true, // 设置成单日历
                    'showDropdowns': true
                }, function(start, end, label) {
                    _this.bjx_form.start_time_str = start.format('YYYY-MM-DD HH:mm');
                });
            },

            // 报表进货价显示设置弹窗、修改
            openBjxModify: function(row) {
                let _this = this;

                _this.bjx_form = {
                    shop_id: row.shop_id,
                    finance_buying_price_type: row.finance_buying_price_type, //1最新进货价 2平均进货价
                    scene: [], //影响最新进货价的采购类型,1采购 2赠送 3盈余 4换货 5 客遗
                    limit_purchase: '-1', //取值范围,-1表示所有  如果是最新进货价的传空或者不传该参数或者原样传回
                    start_time_str: '', //起效时间 如果是最新进货价的传空或者不传该参数或者原样传回
                }
                // $(_this.$refs.bjxSel).val(row.finance_buying_price_type).trigger('change');
                _this.getBuyingPriceSetDetail(row)
            },

            // 获取进货价设置详情
            getBuyingPriceSetDetail(row) {
                let _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": row.shop_id,
                            "finance_buying_price_type": row.finance_buying_price_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getBuyingPriceSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.bjx_form = {
                                shop_id: row.shop_id,
                                finance_buying_price_type: row.finance_buying_price_type, //1最新进货价 2平均进货价
                                scene: data.response.result.scene.split(","), //影响最新进货价的采购类型,1采购 2赠送 3盈余 4换货 5 客遗
                                limit_purchase: data.response.result.limit_purchase,
                                start_time_str: data.response.result.start_time_str
                            }
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: ['确定', '取消'],
                                title: ['修改', true],
                                area: ['500px', ''],
                                content: $(_this.$refs.bjxAlert),
                                offset: '100px'
                            }, function() {
                                let datas = {
                                    "header": Vue.request_header,
                                    "request": {
                                        "version": Vue.version,
                                        "param": {
                                            "shop_id": _this.bjx_form.shop_id,
                                            "finance_buying_price_type": _this.bjx_form.finance_buying_price_type,
                                            "scene": _this.bjx_form.scene.join(","),
                                            "limit_purchase": _this.bjx_form.limit_purchase,
                                            "start_time_str": _this.bjx_form.start_time_str
                                        }
                                    },
                                    "comment": ""
                                };
                                let datas2 = JSON.stringify(datas);
                                $.ajax({
                                    type: "post",
                                    dataType: "json",
                                    url: Vue.ctUrl + "shop/setFinanceBuyingPriceType",
                                    crossDomain: true,
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                    data: {
                                        json: datas2
                                    },
                                    success: function(data) {
                                        if(data.response.result_code == "true") {
                                            layer.closeAll();
                                            _this.upGoodsBuyingPriceData(_this.bjx_form.shop_id, 1)
                                            var layerLoader = layer.load(2, {
                                                shade: [0.8, '#000'],
                                                content: '数据更新中，由于更新数据较大，请耐心等待！且请勿关闭窗口，如中途关闭则会导致数据更新失败！',
                                                success: function (layero) {
                                                    layero.find('.layui-layer-content').css({
                                                        'paddingTop': '40px',
                                                        'width': '250px',
                                                        'textAlign': 'center',
                                                        'backgroundPositionX': 'center',
                                                        'color': '#fff'
                                                    });
                                                }
                                            })
                                        } else {
                                            layer.closeAll();
                                            Vue.timeoutfun(data.response.result_status, _this);
                                            layer.msg(data.response.error_msg);
                                        }
                                    },
                                    error: function(err) {
                                        layer.msg("出错啦");
                                    }
                                });
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 更新进货价
            upGoodsBuyingPriceData(shop_id, page) {
                let _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "page": page
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "MerchantGoods/upGoodsBuyingPriceData",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if (data.response.result.up_status == 1) { // 1进行中 2完成
                                _this.upGoodsBuyingPriceData(shop_id, data.response.result.page)
                            }else if (data.response.result.up_status == 2) {
                                layer.closeAll()
                                layer.msg("更新成功");
                                $(_this.$refs.bjxList).bootstrapTable("refresh");
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            handleCheckAllChange(val) {
                this.bjx_form.scene = val ? ['1','2','3','4','5'] : [];
                this.isIndeterminate = false;
            },

            handleCheckedSceneChange(value) {
                let checkedCount = value.length;
                this.checkAllScene = checkedCount === this.scenes.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.scenes.length;
            },
            onPriceTypeChange() {
                this.bjx_form.scene = ['1','2','3','4','5']
            }
        }
    }
</script>
<style lang="less" scoped>
    // 报表进货价显示设置
    .store-bjx-set {
        .bjx-list {
            h1 {
                margin: 0 0 20px;
            }
            p {
                color: #FF0707;
                margin: 0;
            }
        }
        .bjx-modify {
            .el-select,
            .el-input {
                width: 300px;
                &.big {
                    width: 380px;
                    margin-bottom: 20px;
                }
            }
            .tip {
                margin-bottom: 10px;
            }
        }
    }
</style>